import { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, IconName, DropdownItem } from '@optimus-web/core';
import { openModal as openModalAction } from '../../../app/actions/common';

interface Props {
    icon?: IconName;
    url?: string;
    text?: React.ReactNode;
    openModal?: $TSFixMeFunction;
    onAfterClick?: $TSFixMeFunction;
}

class ModalOpenerActionMenuItem extends Component<Props> {
    handleOnClick = () => {
        const { openModal, url, onAfterClick: close } = this.props;
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        openModal(url);
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        close();
    };

    render() {
        const { icon, text } = this.props;
        return (
            <DropdownItem
                leftDetail={icon && <Icon value={icon} />}
                label={text}
                onClick={this.handleOnClick}
                role="menuitem"
            />
        );
    }
}

export default connect(undefined, {
    openModal: openModalAction,
})(ModalOpenerActionMenuItem);
